/**
 * Theme bootstrap shared between the server layout and the client theme
 * store. Server-safe on purpose (no "use client"): the layout inlines
 * THEME_INIT_SCRIPT into the build-emitted HTML, where the CSP generator
 * (scripts/generate-headers.mjs) allowlists it by hash.
 */
export const THEME_STORAGE_KEY = "wendai.theme";

/**
 * Page background per theme, mirrored into <meta name="theme-color"> so
 * browser window chrome (Safari's tab/status-bar tint) tracks the ACTIVE
 * theme. The stored choice can disagree with the OS scheme, so a static
 * media-query themeColor would lie half the time. Keep in sync with
 * --background in app/globals.css.
 */
export const THEME_COLORS = { light: "#f5f2ec", dark: "#121418" } as const;

/** Resolution order: stored choice, else OS preference. Runs before paint. */
export const THEME_INIT_SCRIPT = `(function(){try{var t=localStorage.getItem(${JSON.stringify(
  THEME_STORAGE_KEY,
)});var d=t?t==="dark":matchMedia("(prefers-color-scheme: dark)").matches;if(d)document.documentElement.classList.add("dark");var m=document.querySelector('meta[name="theme-color"]');if(m)m.setAttribute("content",d?${JSON.stringify(
  THEME_COLORS.dark,
)}:${JSON.stringify(THEME_COLORS.light)})}catch(e){}})()`;
